import React from 'react';
import cx from 'classnames';
import { SLDSDataTableCell } from '@salesforce/design-system-react';

function DataTableCell({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSDataTableCell, Object.assign({}, props, {
    className: cx(className, "tds-table__cell")
  }));
}
DataTableCell.displayName = "DataTableCell";
DataTableCell.displayName = SLDSDataTableCell.displayName;

export { DataTableCell as default };
